import { Component, createResource, Show } from "solid-js";
import { GmodPlayerInput, GmodPlayerSchema } from "@gmod";

const fetchExamplePlayer = async (id: string): Promise<GmodPlayerInput> => {
  const res = await fetch(`http://localhost:8085/gmod/players/example`, {
    headers: { "Content-Type": "application/json" },
  });
  if (!res.ok) {
    throw new Error("Failed to fetch player data");
  }
  const data = await res.json();
  const parsed = GmodPlayerSchema.safeParse(data);
  if (!parsed.success) {
    throw new Error("Failed to parse player data");
  }
  console.log(parsed);
  return parsed.data;
};

export const GModTest: Component = () => {
  const [player, { refetch }] = createResource("player", fetchExamplePlayer);

  return (
    <Show when={!player.loading || !player()} fallback={<p>Loading...</p>}>
      {/* à présent player() est bien typé */}
      <div class="text-lg">
        <p>
          <strong>Steam ID 64:</strong> {player()?.steamID64 ?? "N/A"}
        </p>
        <p>
          <strong>Steam ID:</strong> {player()?.steamID ?? "N/A"}
        </p>
        <p>
          <strong>Name:</strong> {player()?.name ?? "N/A"}
        </p>
        <p>
          <strong>User Group:</strong> {player()?.userGroup ?? "N/A"}
        </p>
        <p>
          <strong>Kills:</strong> {player()?.kills ?? "N/A"}
        </p>
        <p>
          <strong>Deaths:</strong> {player()?.deaths ?? "N/A"}
        </p>
        <p>
          <strong>Connect Time:</strong> {player()?.connectTime ?? "N/A"}
        </p>
        <p>
          <strong>Adjusted Time:</strong> {player()?.adjustedTime ?? "N/A"}
        </p>
        <p>
          <strong>Time Last Team Change:</strong>{" "}
          {player()?.timeLastTeamChange ?? "N/A"}
        </p>
        <p>
          <strong>Ping:</strong> {player()?.ping ?? "N/A"}
        </p>
        <p>
          <strong>FPS:</strong> {player()?.fps ?? "N/A"}
        </p>
        <p>
          <strong>Branch:</strong> {player()?.branch?.branch ?? "N/A"}
        </p>
        <p>
          <strong>Team:</strong> {player()?.team.name ?? "N/A"}
        </p>
        <p>
          <strong>Position:</strong>{" "}
          {`x: ${player()?.position.x ?? "N/A"}, y: ${player()?.position.y ?? "N/A"}, z: ${player()?.position.z ?? "N/A"}`}
        </p>
        <p>
          <strong>Angle:</strong>{" "}
          {`p: ${player()?.angle.p ?? "N/A"}, y: ${player()?.angle.y ?? "N/A"}, r: ${player()?.angle.r ?? "N/A"}`}
        </p>

        <p>
          <strong>Custom Values:</strong>{" "}
          {JSON.stringify(player()?.customValues?.customValues ?? "N/A")}
        </p>
        <button
          class="bg-blue-500 text-white px-4 py-2 rounded"
          onClick={() => refetch()}
        >
          Refetch Player
        </button>
      </div>
    </Show>
  );
};
